import StorageUtil from './StorageUtil';

export const TIPO_ARMAZENAMENTO_LOCAL = {
    IndexedDB: 'IndexedDB',
    localStorage: 'localStorage'
};

/**
 * @classdesc Classe de parâmetros de configuração do sistema
 */
export default class Configuracao {
    // Configurações técnicas
    static PROJECT_NAME = 'secretaria-eletronica';
    static ID_SISTEMA = 'SE'; // 3
    static CONFIG_URL = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/env.json' : '/env.json';
    static APP_JSON = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/app.json' : '/app.json';
    static HABILITAR_SENTRY = true;
    static HABILITAR_HOTJAR = false;
    static HABILITAR_PJEOFFICEPRO = false;
    static FORMATO_DATAHORA_SERVICOS_PADRAO = 'DD-MM-YYYY-HH-mm-ss';
    static HISTORICO_RASCUNHO_CERTIDAO_PREFIXO_STORAGES = StorageUtil.PREFIXO_NOME_STORAGE + 'rascunho-certidao_';
    static HISTORICO_RASCUNHO_CERTIDAO_TIPO_ARMAZENAMENTO = TIPO_ARMAZENAMENTO_LOCAL.IndexedDB;
    static HISTORICO_RASCUNHO_CERTIDAO_FORMATO_DATAHORA = 'YYYY-MM-DD-HH-mm-ss-SSS';
    static QTD_MAXIMA_CARACTERES_TEXTO_PADRAO = 4000;
    static PERFIS_AUTORIZADOS = ['Diretor de Secretaria', 'Servidor'];

    // Constantes
    static PERFIL_SERVIDOR_GABINETE = 'Servidor de Gabinete';
    static PERFIL_ASSESSOR = 'Assessor';
    static PERFIL_MAGISTRADO = 'Magistrado';
    static ORIGEM_SIJ = 'Esij';
    static ORIGEM_PJE = 'PJe';
    static TIPO_PAUTA_ORDINARIA = 'O';
    static TIPO_PAUTA_EXTRAORDINARIA = 'E';
    static PENDENCIA_PROCESSO_NAO_LIBERADO = 'PROCESSO_NAO_LIBERADO';
    static STATUS_ABERTA = 'ABERTA';
    static STATUS_AGUARDANDO_SESSAO_JULGAMENTO = 'AGUARDANDO_SESSAO_JULGAMENTO';
    static STATUS_INICIADA = 'INICIADA';
    static STATUS_FECHADA = 'FECHADA';
    static STATUS_NAO_GERENCIADA_FECHADA = 'NAO_GERENCIADA_FECHADA';
    static STATUS_NAO_GERENCIADA_ABERTA = 'NAO_GERENCIADA_ABERTA';
    static STATUS_NAO_GERENCIADA_ENCERRADA = 'NAO_GERENCIADA_ENCERRADA';
    static STATUS_ENCERRADA = 'ENCERRADA';
    static STATUS_PLENARIO_VIRTUAL = 'PLENARIO_VIRTUAL';
    static STATUS_NAO_GERENCIADA_PLENARIO_VIRTUAL = 'NAO_GERENCIADA_PLENARIO_VIRTUAL';
    static COD_COMPLEMENTO_PARTE = 1;
    static COD_COMPLEMENTO_CLASSE = 5014;
    static TIPO_COMPLEMENTO_DOMINIO = 'DOMINIO';
    static TIPO_COMPLEMENTO_LIVRE = 'LIVRE';
    static TIPO_COMPLEMENTO_DINAMICO = 'DINAMICO';
    static MODO_ASSINATURA_JTE = 'JTe';
    static MODO_ASSINATURA_SHODO = 'shodo';
    static MODO_ASSINATURA_PJEOFFICEPRO = 'pjeofficepro';

    // Configurações de UX
    static DEFAULT_AXIOS_TIMEOUT = 900000;
    static DEFAULT_MOBX_TIMEOUT = 900000;
    static INTERVALO_TEMPO_VERIFICACAO_CONECTIVIDADE_REDE = 10000;
    static TEMPO_PADRAO_EXIBICAO_MENSAGEM = 3000;
    static TAMANHO_PAGINA = 40;
    static MAX_REGISTROS_AUTOCOMPLETE = 200;
    static HISTORICO_RASCUNHO_CERTIDAO_TEMPO_EXPIRACAO_MINUTOS = 21600; // 15 dias
    static CACHE_MINUTAS_VOTOS_TEMPO_EXPIRACAO_MINUTOS = 43200; // 30 dias

    // Configurações de negócio
    static OCULTAR_VOTACAO_SESSAO_PRESENCIAL = true;
    static VISUALIZADOR_VERSAO_MINUTA_VOTO__EXIBIR_VERSOES_SEM_ALTERACAO_CONTEUDO = true;
    static EXIBIR_RESULTADO_JULGAMENTO_ANTES_DO_FIM_DO_PERIODO_VIRTUAL_PARA_O_PUBLICO_EXTERNO = true; // Necessário para justificar a ocultação da minuta de voto no sistema de acompanhamento público
    static TXT_CERTIDAO_RESULTADOS = {
        A: '\n\npor solicitação d{0} {1}, {2}, adiar o julgamento do processo.',
        R: '\n\npor solicitação d{0} {1}, {2}, retirar o processo de pauta.',
        P: '\n\npor solicitação d{0} {1}, {2}, suspender o julgamento do processo.',
        B: '\n\npor solicitação d{0} {1}, {2}, sobrestar o julgamento do processo.',
        V: '\n\nem virtude de pedido de vista regimental formulado {0}suspender o julgamento do processo, após consignado o voto d{1} {2}, {3}, no sentido de',
        D: '\n\nconverter o julgamento em diligência.',
        F: '\n\nacolher a proposta de afetação.',
        E: '\n\nrejeitar a proposta de afetação.'
    };
}
